import { render, staticRenderFns } from "./ChipDefault.vue?vue&type=template&id=5a7a5732&"
import script from "./ChipDefault.vue?vue&type=script&lang=js&"
export * from "./ChipDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports